<template>
    <div class="about" style="padding: 20px">
        <v-breadcrumbs :items="breadcrumbs">
            <template v-slot:divider>
                <v-icon>mdi-forward</v-icon>
            </template>
        </v-breadcrumbs>
        <h1>Create Community</h1>
        <v-form
                enctype="multipart/form-data"
                ref="form"
                v-model="valid"
        >
            <v-card outlined :loading="loading.general">
                <v-card-title>
                    General
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col
                                cols="12"
                                md="6"
                        >
                            <v-text-field
                                    v-model="dados.name"
                                    :counter="200"
                                    maxlength="200"
                                    label="Name"
                                    required
                            ></v-text-field>
                        </v-col>
                        <v-col
                                cols="12"
                                md="6"
                        >
                            <v-text-field
                                    v-model="dados.title"
                                    :counter="200"
                                    maxlength="200"
                                    label="Meta Title"
                                    required
                            ></v-text-field>
                        </v-col>
                        <v-col
                                cols="12"
                                md="6"
                        >
                            <v-text-field
                                    v-model="dados.description"
                                    :counter="200"
                                    maxlength="200"
                                    label="Meta Description"
                                    required
                            ></v-text-field>
                        </v-col>
                        <v-col
                                cols="12"
                                md="6"
                        >
                            <v-text-field
                                    v-model="dados.keywords"
                                    :counter="200"
                                    maxlength="200"
                                    label="Meta Keywords"
                                    required
                            ></v-text-field>
                        </v-col>
                        <v-col
                                cols="12"
                                md="6"
                        >
                            <v-text-field
                                    v-model="dados.url"
                                    :counter="200"
                                    maxlength="200"
                                    label="URL"
                                    required
                            ></v-text-field>
                        </v-col>
                        <v-col
                                cols="12"
                                md="6"
                        >
                            <v-text-field
                                    v-model="dados.location"
                                    :counter="200"
                                    maxlength="200"
                                    label="Location"
                                    required
                            ></v-text-field>
                        </v-col>
                        <v-col
                                cols="12"
                                md="6"

                        >
                            <v-switch v-model="dados.status" class="ma-4" label="Active"></v-switch>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
            <br>
            <v-card outlined :loading="loading.general">
                <v-card-title>
                    Images
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <!-- images -->
                        <v-col
                                cols="12"
                                md="12"
                                sm="12"
                                xs="12"

                        >
                            <v-file-input
                                    multiple
                                    prepend-icon="mdi-camera"
                                    show-size
                                    counter
                                    small-chips
                                    v-model="file"
                                    label="Images (800x600)"
                                    accept="image/*"
                                    @change="onFileChange"
                            ></v-file-input>
                            <v-row dense>
                                <v-col
                                        v-for="(image,index) in imageUrl"
                                        :key="index"
                                        cols="6"
                                        md="2"
                                        sm="3"
                                        xs="6"
                                >
                                    <v-card>
                                        <v-img
                                                :src="image.src"
                                                class="white--text align-end"
                                                gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                                        >
                                            <v-card-title v-text="image.ordem"></v-card-title>
                                        </v-img>
                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-text-field
                                                    v-model="image.ordem"
                                                    label="Sort"
                                                    @change="sortImage(index)"
                                            ></v-text-field>
                                            <v-btn icon @click="deleteImage(index)">
                                                <v-icon>mdi-delete</v-icon>
                                            </v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
            <br>
            <v-tabs
                    :grow="true"
                    background-color="indigo"
                    dark
            >
                <v-tab @click="language='en'">English</v-tab>
                <v-tab @click="language='pt'">Portuguese</v-tab>
                <v-tab @click="language='es'">Spanish</v-tab>
            </v-tabs>
            <v-card outlined :loading="loading.general">
                <v-card-title>
                    Descriptions
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <!-- EN -->
                        <v-col
                                cols="12"
                                v-if="language=='en'"
                        >
                            <v-textarea
                                    outlined
                                    label="Short Description"
                                    v-model="dados.short_description_en"
                            ></v-textarea>
                        </v-col>
                        <v-col
                                cols="12"
                                v-if="language=='en'"
                        >
                            <span>Description</span>
                            <vue-editor v-model="dados.en"></vue-editor>
                        </v-col>
                        <!-- PT -->
                        <v-col
                                cols="12"
                                v-if="language=='pt'"
                        >
                            <v-textarea
                                    outlined
                                    label="Short Description"
                                    v-model="dados.short_description_pt"
                            ></v-textarea>
                        </v-col>
                        <v-col
                                cols="12"
                                v-if="language=='pt'"
                        >
                            <span>Description</span>
                            <vue-editor v-model="dados.pt"></vue-editor>
                        </v-col>
                        <!-- ES -->
                        <v-col
                                cols="12"
                                v-if="language=='es'"
                        >
                            <v-textarea
                                    outlined
                                    label="Short Description"
                                    v-model="dados.short_description_es"
                            ></v-textarea>
                        </v-col>
                        <v-col
                                cols="12"
                                v-if="language=='es'"
                        >
                            <span>Description</span>
                            <vue-editor v-model="dados.es"></vue-editor>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
            <br>
            <div v-if="erro">
                <v-alert type="error" dense outlined  v-for="(item,index) in msg" :key="index">
                    {{ item }}
                </v-alert>
            </div>
            <div v-else>
                <v-alert type="success" dense outlined  v-for="(item,index) in msg" :key="index">
                    {{ item }}
                </v-alert>
            </div>
            <v-btn
                    :loading="loading.general"
                    :disabled="!valid"
                    color="success"
                    class="mr-4"
                    @click="validate"
            >
                Save
            </v-btn>
        </v-form>
    </div>
</template>
<script>
    import { VueEditor } from "vue2-editor";
    export default {
        components: {
            VueEditor
        },
        data: () => ({
            valid:true,
            loading:{
                general:false,
            },
            dados:{
                name:"",
                en:"",
                pt:"",
                es:"",
                title:"",
                description:"",
                keywords:"",
                url:"",
                status:1,
            },
            file: null,
            imageUrl: [],
            erro:true,
            msg:[],
            language:"en",
            breadcrumbs: [
                {
                    text: 'Dashboard',
                    disabled: false,
                    to: '/',
                },
                {
                    text: 'Community',
                    disabled: false,
                    to: '/condominiums',
                },
                {
                    text: 'Create Community',
                    disabled: true,
                    to: '/house',
                },
            ],
        }),
        methods: {
            onFileChange() {
                var files = this.file;
                if (files) {
                    [].forEach.call(files, this.readAndPreview);
                }
            },
            readAndPreview(file){
                if ( /\.(jpe?g|png|gif)$/i.test(file.name) ) {
                    let reader = new FileReader();
                    reader.onload = () => {
                        this.imageUrl.push({
                            src:reader.result,
                            ordem:(this.imageUrl.length+1),
                            type:file.type
                        });
                    }
                    reader.readAsDataURL(file);
                }else{
                    console.log("Invalid Format");
                }
            },
            montArrImages(){
                var iidice = 0;
                var arr = [];
                this.imageUrl.forEach(function(val){
                    arr[iidice] = val;
                    iidice = iidice+1;
                });
                this.imageUrl = arr;
                for (var i = 0; i < this.imageUrl.length; i++) {
                    this.imageUrl[i].ordem = (i+1);
                }
            },
            sortImage(indice){
                this.imageUrl[indice].ordem = parseInt(this.imageUrl[indice].ordem);
                var newIndice = parseInt((this.imageUrl[indice].ordem-1));
                if(!(newIndice)){
                    newIndice = 0;
                }
                if(newIndice < 0){
                    newIndice = 0;
                }
                //verifico se a nova ordem digitada já pertence a uma chave
                if(this.imageUrl[newIndice]){
                    console.log('1');
                    var arr = this.imageUrl[newIndice];
                    arr.ordem = this.imageUrl[indice].ordem;
                    this.imageUrl[newIndice] = this.imageUrl[indice];
                    this.imageUrl[indice] = arr;
                    this.montArrImages();
                }
                //caso não exista altero a chave da atual para a ordem
                else{
                    console.log('0');
                    this.imageUrl[newIndice] = this.imageUrl[indice];
                    this.deleteImage(indice);
                }
            },
            deleteImage(indice){
                this.imageUrl.splice(indice,1);
                this.montArrImages();
            },
            validate () {
                this.loading.general = true;
                this.erro = false;
                this.dados.image = this.imageUrl;
                var arr = JSON.stringify(this.dados);
                this.$http.post("https://api.bestchoicevacation.com/condominiums/create",arr,{
                    headers: {
                        'x-access-token': localStorage.hash
                    }
                }).then(response => {
                    this.loading.general = false;
                    this.msg = response.data.msg;
                    if(response.data.erro == '1'){
                        this.erro = true;
                    }else{
                        this.dados.name = "";
                        this.dados.en = "";
                        this.dados.es = "";
                        this.dados.pt = "";
                        this.dados.description = "";
                        this.dados.title = "";
                        this.dados.description = "";
                        this.dados.keywords = "";
                        this.dados.url = "";
                        this.imageUrl = [];
                    }
                });

            }
        },
        mounted(){

        }
    }
</script>